/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const listDeliveriesPathParamsSchema = z.object({
    "id": z.string().describe("Event subscription identifier")
    })

export const listDeliveriesQueryParamsSchema = z.object({
    "pageSize": z.optional(z.any().describe("Items per page (default 25, max 100)")),
"page": z.optional(z.any().describe("Page number (default 1)")),
"name": z.optional(z.any().describe("Case-insensitive substring match on the delivered contact’s name")),
"isTest": z.optional(z.any().describe("Filter by whether the delivery was a test drill (true) or a real event (false). Omit to include both.")),
"status": z.optional(z.any().describe("Filter by delivery status (pending, succeeded, failed)"))
    }).optional()

/**
 * @description Deliveries page, most recent first
 */
export const listDeliveries200Schema = z.object({
    "items": z.array(z.object({
    "id": z.string(),
"subscriptionId": z.string(),
"userId": z.string(),
"eventType": z.enum(["contact.event.detected", "contact.summary.completed"]),
"resourceId": z.string(),
"isTest": z.boolean(),
"eventSummary": z.nullable(z.object({
    "contactName": z.nullable(z.string()),
"type": z.nullable(z.string())
    })),
"status": z.enum(["pending", "succeeded", "failed"]),
"attemptCount": z.int().min(-9007199254740991).max(9007199254740991),
"responseCode": z.nullable(z.int().min(-9007199254740991).max(9007199254740991)),
"timeTakenMs": z.nullable(z.int().min(-9007199254740991).max(9007199254740991)),
"errorMessage": z.nullable(z.string()),
"lastAttemptAt": z.nullable(z.iso.datetime()),
"createdAt": z.iso.datetime(),
"updatedAt": z.iso.datetime()
    })),
"total": z.int().min(-9007199254740991).max(9007199254740991),
"page": z.int().min(-9007199254740991).max(9007199254740991),
"pageSize": z.int().min(-9007199254740991).max(9007199254740991)
    })

/**
 * @description Invalid query params
 */
export const listDeliveries400Schema = z.any()

/**
 * @description Caller is not an admin
 */
export const listDeliveries403Schema = z.any()

/**
 * @description Event subscription not found
 */
export const listDeliveries404Schema = z.any()

export const listDeliveriesQueryResponseSchema = z.lazy(() => listDeliveries200Schema)